export default class Services {

}

